import React from 'react';

import PlusIcon from '../common/PlusIcon';

const AddModifier = ({ onClick }) => (
  <button type="button" className="add-menu-modifier" onClick={onClick}>
    <PlusIcon />
    <h5>Create Modifier</h5>
  </button>
);

export default AddModifier;
